import { cn } from '@/utils'

export const DocumentTextIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="13"
      height="15"
      viewBox="0 0 13 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('stroke-gray-800', className)}
    >
      <path
        d="M7.46354 0.799805H2.13021C1.77659 0.799805 1.43745 0.94028 1.1874 1.19033C0.937351 1.44038 0.796875 1.77952 0.796875 2.13314V12.7998C0.796875 13.1534 0.937351 13.4926 1.1874 13.7426C1.43745 13.9927 1.77659 14.1331 2.13021 14.1331H10.1302C10.4838 14.1331 10.823 13.9927 11.073 13.7426C11.3231 13.4926 11.4635 13.1534 11.4635 12.7998V4.7998M7.46354 0.799805L11.4635 4.7998M7.46354 0.799805L7.46354 4.7998H11.4635M4.13021 9.46647H8.13021"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
